import { useEffect, useState } from "react";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import { useStorePicker, useNearestStore } from "../hooks/useStorePicker";

export const MobileStickyContact = () => {
  const { open } = useStorePicker();
  const nearest = useNearestStore();
  const [hidden, setHidden] = useState(false);

  // Hide on scroll up to nav, show again on scroll down — keeps top of page clean.
  useEffect(() => {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      // Show after scrolled past hero (~300px)
      setHidden(y < 300);
      lastY = y;
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!nearest) return null;

  const phoneHref = `tel:${(nearest.phone || "").replace(/\s/g, "")}`;
  const waHref = nearest.whatsapp || "#";

  const handleCall = (e) => {
    // If we have multiple stores, give user the picker; if only nearest known, call directly.
    // Always open picker so user can override.
    e.preventDefault();
    open("call");
  };
  const handleWa = (e) => {
    e.preventDefault();
    open("whatsapp");
  };

  return (
    <div
      className={`sm:hidden fixed bottom-0 inset-x-0 z-40 transition-transform duration-300 ${
        hidden ? "translate-y-full" : "translate-y-0"
      }`}
      data-testid="mobile-sticky-contact"
    >
      <div className="bg-white border-t border-sky-100 shadow-[0_-8px_24px_-12px_rgba(2,132,199,0.25)] px-3 py-2.5">
        <div className="flex items-center gap-2 mb-1.5 px-1">
          <MapPin className="w-3 h-3 text-sky-600 flex-shrink-0" />
          <p className="text-[11px] text-slate-500 truncate">
            Nearest store: <span className="font-semibold text-slate-700">{nearest.name}</span>
          </p>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <a
            href={phoneHref}
            onClick={handleCall}
            className="flex items-center justify-center gap-2 py-3 rounded-xl bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold shadow-sm"
            data-testid="mobile-sticky-call-btn"
          >
            <Phone className="w-4 h-4" />
            Call Now
          </a>
          <a
            href={waHref}
            onClick={handleWa}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 py-3 rounded-xl bg-green-500 hover:bg-green-600 text-white text-sm font-semibold shadow-sm"
            data-testid="mobile-sticky-wa-btn"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};
